import { gql, useSubscription } from '@apollo/client';
import type {
  OnScheduledEventUpdateByEidSubscription,
  OnScheduledEventUpdateByEidSubscriptionVariables
  // eslint-disable-next-line import/no-internal-modules
} from './__generated__/use-subscription';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useEventSubscription = (eid: string) =>
  useSubscription<
    OnScheduledEventUpdateByEidSubscription,
    OnScheduledEventUpdateByEidSubscriptionVariables
  >(
    gql`
      subscription OnScheduledEventUpdateByEID($eid: String!) {
        onUpdateScheduledEventByEid(eid: $eid) {
          id
          cid
          eid
          muxStreamUrl
          organizationName
          backgroundUrl
          cueSheetUrl
          description
          endTime
          eventPassword
          eventType
          hidden
          isLive
          isOperated
          isSimulatedLive
          locationId
          name
          operatorNotes
          startTime
          status
          streamFacebook
          streamRtmp
          streamYoutube
          streamZoom
          streamLive
          visibility
          zoomMeetingId
          zoomPassword
          client {
            backgroundUrl
            cid
            organizationName
            timezone
          }
        }
      }
    `,
    {
      variables: {
        eid
      }
    }
  );
